import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
const uuid = require('uuid');

const ActivityActions = require('../../actions/ActivityActions');
const ActivityStore = require('../../stores/activity_store_reflux');
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    project_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    activity_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    nova_act_id: PropTypes.string.isRequired,
    userName: PropTypes.string,
    lockUserName: PropTypes.string,
    closeHandler: PropTypes.func.isRequired,
};

const defaultProps = {};

class ForceUnlockModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            text: "This action will bounce " + (props.lockUserName || "the other user") + " out of their editing session after a short timed prompt.",
            error: null,
            waitingText: '',
            actionID: null,
            waiting: false,
        };

        this.getWaitText = this.getWaitText.bind(this);
        this.tickWaitCountdown = this.tickWaitCountdown.bind(this);
        this.forceUnlockHandler = this.forceUnlockHandler.bind(this);

        this.unsubscribes = [
            ActivityStore.listen(this.onActivityStoreStateChange.bind(this))
        ];
    }

    componentWillUnmount() {
        if (this.waitTimer) {
            window.clearTimeout(this.waitTimer);
            delete this.waitTimer;
        }
        this.unsubscribes.forEach(unsubscribeCallback => { unsubscribeCallback(); });
    }

    onActivityStoreStateChange(storeState) {
        var action = storeState.action;
        if (action && this.state.actionID && (action.id === this.state.actionID)) {
            if (this.waitTimer) {
                window.clearTimeout(this.waitTimer);
                delete this.waitTimer;
            }

            if (action.error) {
                this.setState({
                    waiting: false,
                    waitingText: '',
                    error: action.error,
                });
            }
            else {
                this.props.closeHandler();
            }
        }
    }
    
    getWaitText(waitSeconds) {
        return 'Waiting for unlock confirmation...  ' + waitSeconds;
    }
    
    tickWaitCountdown(waitSeconds) {
        if ((waitSeconds <= 0) || !this.waitTimer) {
            this.props.closeHandler();
        }
        else {
            this.setState({
                waitingText: this.getWaitText(waitSeconds),
            }, () => {
                this.waitTimer = window.setTimeout(this.tickWaitCountdown.bind(this, waitSeconds - 1), 1000);
            });
        }
    }
    
    forceUnlockHandler() {
        const actionID = uuid.v4();
        const waitSeconds = Math.ceil(GlobalConfig.WebSocketOptions.forceUnlockTime/1000);
        this.setState({
            actionID: actionID,
            waiting: true,
            waitingText: this.getWaitText(waitSeconds),
        }, () => {
            ActivityActions.forceUnlockActivity(actionID, {
                id: this.props.activity_id,
                projectId: this.props.project_id,
                nova_act_id: this.props.nova_act_id,
                kickerName: this.props.userName,
            });
            this.waitTimer = window.setTimeout(this.tickWaitCountdown.bind(this, waitSeconds - 1), 1000);
        });
    }
    
    render() {
        return (
            <Modal
                show
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard={true}
                onHide={this.props.closeHandler}
            >

                <Modal.Header closeButton={this.state.waiting} onHide={this.props.closeHandler}>
                    <Modal.Title>{'Force Clear Edit Lock'}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {this.state.error ? <ErrorBox error={this.state.error}/> : null}
                    {this.state.waiting ? this.state.waitingText : this.state.text}
                </Modal.Body>

                <Modal.Footer>
                    { this.state.waiting ?
                        null
                        : 
                        <span>
                            <Button disabled={this.state.waiting} onClick={this.forceUnlockHandler} className="margin-right-md">unlock</Button>
                            <Button disabled={this.state.waiting} onClick={this.props.closeHandler}>cancel</Button>
                        </span>
                    }
                </Modal.Footer>
            </Modal>
        );
    }
}

ForceUnlockModal.propTypes = propTypes;
ForceUnlockModal.defaultProps = defaultProps;

export default ForceUnlockModal;